import { X } from 'lucide-react';

import { POOP_LEVELS, PEE_LEVELS } from '../lib/format.js';

function FeedOverlay({ selected, feedType, side, amount }) {
  const nursing = feedType === 'nursing';
  return (
    <div className="gesture-feed-zones">
      {!nursing ? <div className={`gesture-zone gesture-zone--breast ${selected === 'breastmilk' ? 'is-selected' : ''}`}>
        <strong>母乳瓶喂</strong>
        <span>{selected === 'breastmilk' ? `${amount} ml` : '滑到这里'}</span>
      </div> : null}
      {!nursing ? <div className={`gesture-zone gesture-zone--formula ${selected === 'formula' ? 'is-selected' : ''}`}>
        <strong>奶粉瓶喂</strong>
        <span>{selected === 'formula' ? `${amount} ml` : '滑到这里'}</span>
      </div> : null}
      {!nursing ? <div className={`gesture-zone gesture-zone--nursing ${selected === 'nursing' ? 'is-selected' : ''}`}>
        <strong>亲喂</strong><span>{selected === 'nursing' ? '继续滑动选左右' : '滑到这里'}</span>
      </div> : null}
      {nursing ? <>
        <div className={`gesture-zone gesture-zone--left ${side === 'left' ? 'is-selected' : ''}`}><strong>左侧</strong><span>{side === 'left' ? `${amount} 分钟` : '滑到这里'}</span></div>
        <div className={`gesture-zone gesture-zone--right ${side === 'right' ? 'is-selected' : ''}`}><strong>右侧</strong><span>{side === 'right' ? `${amount} 分钟` : '滑到这里'}</span></div>
      </> : null}
      <div className="gesture-readout">
        <span>{nursing ? (side ? '保持增加亲喂时长' : '滑到左侧或右侧') : (selected ? '保持增加奶量' : '滑动选择喂养方式')}</span>
        <strong>{amount && selected !== 'cancel' ? `${amount} ${nursing ? '分钟' : 'ml'}` : '—'}</strong>
        <small>松手保存</small>
      </div>
    </div>
  );
}

function LevelOverlay({ kind, selected }) {
  const labels = kind === 'poop' ? POOP_LEVELS : PEE_LEVELS;
  return (
    <div className={`gesture-levels gesture-levels--${kind}`}>
      <div className="gesture-levels__heading">
        <span>{kind === 'poop' ? '选择便量' : '选择尿量'}</span>
        <strong>{selected && selected !== 'cancel' ? labels[selected - 1] : '滑动选择'}</strong>
      </div>
      <div className="gesture-levels__grid" style={{ '--level-count': labels.length }}>
        {labels.map((label, index) => (
          <div key={label} className={`gesture-level ${selected === index + 1 ? 'is-selected' : ''}`}>
            <span>{index + 1}</span>
            <strong>{label}</strong>
          </div>
        ))}
      </div>
      <small>松手保存</small>
    </div>
  );
}

export default function GestureOverlay({ gesture }) {
  if (!gesture) return null;
  return (
    <div className={`gesture-overlay gesture-overlay--${gesture.kind}`} aria-live="polite">
      <div className={`gesture-cancel ${gesture.selected === 'cancel' ? 'is-selected' : ''}`}>
        <X size={22} />
        <strong>滑到这里取消</strong>
      </div>
      {gesture.kind === 'feed'
        ? <FeedOverlay selected={gesture.selected} feedType={gesture.feedType} side={gesture.side} amount={gesture.amount} />
        : <LevelOverlay kind={gesture.kind} selected={gesture.selected} />}
    </div>
  );
}
